<template>
	<span v-html="parsed" />
</template>

<script>
	import i18n from '@/i18n';
	import VariableHelpers from '@/assets/js/variableHelpers.js'
	const opLookup = require('@/assets/js/operators.json').reduce((lookup, op) => {
		lookup[op.name] = op 
		return lookup
	}, {})

	export default {
		name: 'condition-preview',
		props: {
			expression: {
				type: String,
				required: true
			}
		},
		computed: {
			
			parsed () {
				let text = this.expression
				let vars = text.match(/{.*?\}/g)
				let operators = text.match(/(!=NULL|=NULL|>=|!=|<=|=|>|<|contains|notcontains)/g)
				if (operators) operators.forEach(o => {
				let prettyDesc;
				if(i18n.locale == "en"){prettyDesc = opLookup[o].prettyEn;}else{prettyDesc = opLookup[o].pretty;}
					text = text.replace(new RegExp(o, 'g'), ' ' + prettyDesc + ' ') })
				if (vars) new Set(vars).forEach(v => {
					text = text.replace(new RegExp(v, 'g'), '<span class="variable" tooltip="' + VariableHelpers.removeBrackets(v) + '">' + VariableHelpers.getPrettyName(v, this.$store.getters.combinedVariables).toLowerCase() + '</span>')
				})
				return text
			},
		
		}
	}
</script>

<style lang="less">
</style>

